import { EnvironmentProviders, Provider, importProvidersFrom } from '@angular/core';
import { HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';

import { HammerGestureConfigProvider, NgScrollbarOptionsProvider } from '@frontend/sports/common/core/feature/browser';
import { provideSportsDynamicInjector } from '@frontend/sports/host-app/sports-product/feature/sports-product-service';
import { provideLazyFeatures } from '@frontend/sports/web/platform-lib';
import { NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';

/**
 * Provides root services needed for running the Sports-Web application as standalone or in host-app integration.
 * This should include all services which MUST be provided in root.
 * These services will be included in the main bundle for host-app so DO NOT extend this list unless the services should be provided in the host-app root.
 * For other cases, use {@link provideSportsWebCore}
 * @see provideSportsWebCore
 * @returns Providers needed for running Sports-Web.
 */
export function provideSportsWebRootServices(): (Provider | EnvironmentProviders)[] {
    return [
        provideLazyFeatures(),
        provideSportsDynamicInjector(),
        {
            provide: NG_SCROLLBAR_OPTIONS,
            useClass: NgScrollbarOptionsProvider,
        },
        importProvidersFrom(HammerModule),
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: HammerGestureConfigProvider,
        },
    ];
}
